import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_REJECT_SLOT_OPTIONS, GET_REJECT_SLOT_OPTIONS_ERROR, GET_REJECT_SLOT_OPTIONS_SUCCESS } from '../../../actions.js';

function* getRejectSlotOptions({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/vendor/available-slots`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_REJECT_SLOT_OPTIONS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_REJECT_SLOT_OPTIONS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_REJECT_SLOT_OPTIONS_ERROR, payload: error });
  }
}

export function* watchgetRejectSlotOptions() {
  yield takeEvery(GET_REJECT_SLOT_OPTIONS, getRejectSlotOptions);
}

function* getRejectSlotOptionsSaga() {
  yield all([fork(watchgetRejectSlotOptions)]);
}

export default getRejectSlotOptionsSaga;
